export default {
  instructions:
    "Your order will be prepared as soon as you let us know. See option 1 or 2 below.",
  options: {
    option_1: {
      subTitle: "Option 1",
      title: "Order in restaurant",
      description: "Tell the restaurant your FoodAmigos order number",
    },
    option_2: {
      subTitle: "Option 2",
      title: "Call to order ahead",
      description: "Tell them your FoodAmigos order number and pick up time",
    },
  },
};
